/**
 * Moment date display formats
 */
export const DateFormat = {
  DateRange: 'MMM D',
  OrderArrivalDateRange: 'MMM D',
  PastOrderArrivalDate: 'MMM D, YYYY',
};
